<div class="members-format-container">
  <div class="d-flex flex-column gap-2">
    <span class="members-format-title" i18n>Formatting Requirements</span>
    <span class="members-format-subtitle" i18n>
      The following formatting requirements must be followed for a successful file upload:
    </span>
  </div>
  <ol class="members-format-rules">
    <li class="members-format-rule-item">
      <span class="members-format-rule" i18n>The following fields are required for each row:</span>
      <ul class="members-format-list">
        <li i18n>Last Name</li>
        <li i18n>First Name</li>
        <li i18n>Date of Birth</li>
        <li i18n>SIN</li>
        <li i18n>Email</li>
        <li i18n>Employment Start</li>
      </ul>
    </li>
    <li class="members-format-rule-item">
      <span class="members-format-rule" i18n
        >Date of Birth and Employment Start must use one of the accepted formats:</span
      >
      <ul class="members-format-list">
        <li i18n>January 8, 1990</li>
        <li i18n>Jan 8, 1990</li>
        <li i18n>08-01-1990 (DD-MM-YYYY)</li>
        <li i18n>08011990 (DDMMYYYY)</li>
      </ul>
    </li>
    <li class="members-format-rule-item">
      <span class="members-format-rule" i18n>The following columns must contain only numeric values:</span>
      <ul class="members-format-list">
        <li i18n>SIN</li>
      </ul>
    </li>
  </ol>
</div>
